import { Get } from '../../api/axiosCoreConfig';

export const getEntityChoices = (namespace) => Get(`/entity/choice?namespace=${namespace}`);
export const getAnEntityReports = (entity, namespace) =>
    Get(`/entity/export/${entity}${namespace ? '?namespace=' + namespace : ''}`, {
        responseType: 'blob'
    });
